import { SessionContext } from "kmstack-shared";

export const toNumber = (v: any, fallback = 0) => {
	if (v === undefined || v === null || v === '') return fallback;
	const n = typeof v === 'number' ? v : Number(String(v).replace(/[^0-9.-]/g, ''));
	return Number.isNaN(n) ? fallback : n;
};



export const getUserMembershipForActiveOrg = (sessionContext: SessionContext | null | undefined) => {
	if (!sessionContext) return null;
	if (sessionContext.activeMembership) return sessionContext.activeMembership;
	const activeOrgId = sessionContext.activeOrganization?.id;
	if (!activeOrgId) return null;
	const membership = sessionContext.user.memberships.find(e => e.org.id === activeOrgId);
	return membership || null;
};


export { formatCurrency, fieldBaseConfig, getInitials, formatMoney } from 'kmstack-shared/apps/common';
